import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import RadioChecked from "rialto-icons/RadioChecked";
import RadioUnchecked from "rialto-icons/RadioUnchecked";

import styles from "./Radio.css";

const Radio = ({ children, isChecked, isInvalid, label, onChange }) => (
  <div
    className={cx(styles.radio, {
      [styles.selected]: isChecked,
      [styles.error]: isInvalid,
    })}
    onClick={onChange}
  >
    {isChecked ? <RadioChecked /> : <RadioUnchecked />}
    {label && <span className={styles.label}>{label}</span>}
    {children}
  </div>
);

Radio.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Radio;
